import React from 'react';

import dictionary from 'config/dictionary';
import styles from './scheduled-maintenance-banner.module.scss';

const ScheduledMaintenanceBanner = () => {
  return dictionary.scheduledMaintenanceBanner.text ? (
    <div className={styles.banner}>
      {dictionary.scheduledMaintenanceBanner.text
        .split('\n')
        .map((line, index) => (
          <p key={index}>{line}</p>
        ))}
    </div>
  ) : null;
};

ScheduledMaintenanceBanner.propTypes = {};

export default ScheduledMaintenanceBanner;
